import React from 'react';
import { HiOutlineShoppingBag } from 'react-icons/hi';
import { useCart } from '../context/CartContext';
import { motion, AnimatePresence } from 'framer-motion';

const CartButton = () => {
  const { cart, setIsCartOpen } = useCart();

  // El botón solo aparecerá si hay al menos un producto
  const hasItems = cart.length > 0;

  return (
    <AnimatePresence>
      {hasItems && (
        <motion.button
          initial={{ scale: 0, y: 20 }}
          animate={{ scale: 1, y: 0 }}
          exit={{ scale: 0, y: 20 }}
          onClick={() => setIsCartOpen(true)}
          /* md:hidden -> Oculta el botón en pantallas medianas y grandes (Desktop)
             flex -> Se muestra en pantallas pequeñas (Móvil)
          */
          className="fixed bottom-6 right-6 z-[900] md:hidden bg-[#1C1C1C] text-white p-4 rounded-full shadow-2xl flex items-center gap-3 active:scale-95 transition-transform"
        >
          <div className="relative">
            <HiOutlineShoppingBag className="text-2xl" />
            <span className="absolute -top-2 -right-2 bg-[#F26B1D] text-white text-[10px] font-black w-5 h-5 flex items-center justify-center rounded-full border-2 border-[#1C1C1C]">
              {cart.length}
            </span>
          </div>
          <span className="text-xs font-bold uppercase tracking-widest pr-2">
            Mi Pedido
          </span>
        </motion.button>
      )}
    </AnimatePresence>
  );
};

export default CartButton;